










import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { LanguageDto, UserDto } from "@/server/app.dtos";
import { GridColumn, GridColumnTypes } from "@/models/grids/column";
import ConfigsService from "@/services/api/configs.service";

@Component
export default class UserDetailLoginsPage extends Vue {
  @Prop() user!: UserDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  configsService: ConfigsService = new ConfigsService();

  columns: GridColumn[] = [
    {
      text: "Username",
      value: "username",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.required]
    },
    {
      text: "Data de Criação",
      value: "dateCreated",
      type: GridColumnTypes.DateTime,
      editable: false
    },
    {
      text: "Recuperando a senha?",
      value: "IsRecovering",
      type: GridColumnTypes.Boolean,
      editable: false,
    }, 
    {
      text: "Senha",
      value: "password",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.required]
    },
    {
      text: "Acessos",
      value: "idAppInterfaceRole",
      type: GridColumnTypes.Dropdown,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.required],
      arg: {
        items: [],
        itemText: "title",
        itemValue: "idAppInterfaceRole",
        value: null
      }
    }

  ];
  endpoint: string = "";
  primary: string = "idUserLogin";

  async created() {
    this.endpoint = "api/users/" + this.user.idUser + "/logins";

    const query: string = "IdLanguage=" + this.currentLanguage.idLanguage;
    await this.configsService.Load("api/appInterfaceRoles", query).then((result) => {
      
      this.columns[4].arg.items = result;
      this.columns[4].arg.value = result[0];
    });

  }
}
